import { AppSider } from 'shared/UI/UIKit/Sider';
import { TableFilter } from 'common/TableFilter';
import { MunicipalitiesTable } from './Table/MunicipalitiesTable';
import { MunicipalitiesTableControls } from './Controls/Controls';
import { CreateMunicipalityModal } from './Modals/Create';
import { EditMunicipalityModal } from './Modals/Edit';
import { RemoveMunicipalityModal } from './Modals/Remove';
import { useMunicipalities } from './Municipalities/use-municipalities';

export const Municipalities = () => {
  const { state, methods } = useMunicipalities();

  return (
    <>
      <MunicipalitiesTableControls
        createMunicipality={methods.createMunicipality}
        columns={state.columns}
        visibleKeys={state.visibleKeys}
        setVisibleKeys={methods.setVisibleKeys}
        showSider={methods.showSider}
        filterCount={state.filterCount}
      />
      <MunicipalitiesTable
        loading={state.loading}
        dataSource={state.municipalities}
        columns={state.filteredColumns}
        tableState={state.tableState}
        onChange={methods.onTableChange}
      />
      <CreateMunicipalityModal
        visible={state.createModalVisible}
        hide={() => methods.setCreateModalVisible(false)}
      />
      <EditMunicipalityModal visible={state.editModalVisible} hide={methods.hideEditModal} />
      <RemoveMunicipalityModal
        visible={state.removeModalVisible}
        hide={() => methods.setRemoveModalVisible(false)}
        onItemRemove={methods.onItemRemove}
      />
      <AppSider
        title="Фильтры"
        isSiderVisible={state.siderVisible}
        submitBtnText="Применить"
        cancelBtnText="Сбросить всё"
        hideSider={methods.hideSider}
      >
        <TableFilter
          fields={state.filterFields}
          submitBtnText="Применить"
          resetBtnText="Сбросить всё"
          onSubmit={methods.onFilterChange}
          onClose={methods.hideSider}
          onLoadOptions={methods.onLoadFilterOptions}
          fieldsValue={state.filterState}
        />
      </AppSider>
    </>
  );
};
